// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"tooltip_tooltipWrapper__-v2-t","tooltip":"tooltip_tooltip__3tYUW","text":"tooltip_text__1lp2N"};